import {
  Component,
  OnInit,
  Input,
  Output,
  EventEmitter,
  OnChanges,
  SimpleChanges
} from '@angular/core';
import { HttpService } from 'src/app/core/http/http.service';
import { UnsubscribeOnDestroyAdapter } from 'src/app/core/unsuscribe-adapter/unsuscribe-adapter';
import {
  IAllNotifications,
  INotification
} from 'src/app/shared/models/notifications.model';

@Component({
  selector: 'app-notifications',
  templateUrl: './notifications.component.html',
  styleUrls: ['./notifications.component.scss']
})
export class NotificationsComponent extends UnsubscribeOnDestroyAdapter
  implements OnInit, OnChanges {
  @Input() notifications: INotification[] = [];
  @Input() storePendingNotifications: INotification[] = [];
  @Input() opened: boolean = false;
  @Output() currentNotifications: EventEmitter<
    INotification[]
  > = new EventEmitter();
  public loadingNotifictions: boolean = true;
  @Input() openNotifictionsFirstTime: boolean = false;
  constructor(private service: HttpService) {
    super();
  }

  ngOnInit() {}

  ngOnChanges(changes: SimpleChanges) {
    //If you open de notifications panel and don't have any notification, we get the list of last notifications
    if (
      changes.opened &&
      changes.openNotifictionsFirstTime &&
      this.opened &&
      !this.openNotifictionsFirstTime
    ) {
      this.getLastNotifications();
    } else {
      this.loadingNotifictions = false;
    }

    //If you open de notifications panel and there are notifications pending to see, we report to backend that you see it
    if (this.opened && this.storePendingNotifications.length > 0) {
      this.notifySeen(this.storePendingNotifications.map(item => item.id));
    }
    //If you have the notifications panel opened and receive notifications from socket, we report to backend that you see it
    if (
      this.opened &&
      changes.notifications &&
      changes.notifications.previousValue &&
      changes.notifications.previousValue.length > 0 &&
      this.getNewNotifications(
        changes.notifications.previousValue,
        changes.notifications.currentValue
      ).length > 0
    ) {
      this.notifySeen(
        this.getNewNotifications(
          changes.notifications.previousValue,
          changes.notifications.currentValue
        ).map(item => item.id)
      );
    }
  }

  getLastNotifications(): void {
    this.subs.add(
      this.service
        .get<INotification[]>('notification/list', {})
        .subscribe(rest => {
          this.currentNotifications.emit(rest);
          this.loadingNotifictions = false;
        })
    );
  }

  getNewNotifications(
    oldNotifications: INotification[],
    newNotifications: INotification[]
  ): INotification[] {
    return newNotifications.filter(
      itemNew =>
        oldNotifications.findIndex(oldItem => oldItem.id == itemNew.id) == -1
    );
  }

  notifySeen(elements: number[]): void {
    this.subs.add(
      this.service.put('notification/list', { ids: [...elements] }).subscribe()
    );
  }
}
